import React from "react"
import { storyblokEditable } from "@storyblok/react"

import Markdown from "react-markdown"

import { ThreeColumnText, transformLinkUri } from "gatsby-theme-gba"

const ThreeColumnTextTextEditable = ({ blok }) => {
  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  }

  const replaceAll = (str, term, replacement) =>
    str.replace(new RegExp(escapeRegExp(term), "g"), replacement)

  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <ThreeColumnText
        heading1={blok.heading1}
        heading2={blok.heading2}
        heading3={blok.heading3}
        mode={blok.mode}
        text1={
          <Markdown
            transformLinkUri={(uri) => {
              return transformLinkUri(uri, "", blok.currentLanguage)
            }}
          >
            {replaceAll(blok.text1, "\u2028", "")}
          </Markdown>
        }
        text2={
          <Markdown
            transformLinkUri={(uri) => {
              return transformLinkUri(uri, "", blok.currentLanguage)
            }}
          >
            {replaceAll(blok.text2, "\u2028", "")}
          </Markdown>
        }
        text3={
          <Markdown
            transformLinkUri={(uri) => {
              return transformLinkUri(uri, "", blok.currentLanguage)
            }}
          >
            {replaceAll(blok.text3, "\u2028", "")}
          </Markdown>
        }
        hasBackground={blok.background}
      ></ThreeColumnText>
    </div>
  )
}
export default ThreeColumnTextTextEditable
